module.exports = __webpack_public_path__ + "static/media/grade-level.7ab504dd.png";